"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Sparkles = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 68 68"
}, /*#__PURE__*/_react.default.createElement("g", {
  fill: "#6F6F6F",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M54.439 25.09l3.551-7.757 8.517-3.234c.388-.176.634-.537.634-.932s-.246-.756-.634-.933L57.99 9l-3.551-7.756c-.194-.354-.59-.577-1.024-.577-.433 0-.83.223-1.023.577L48.84 9l-8.518 3.234c-.388.177-.633.538-.633.933s.245.756.633.932l8.518 3.234 3.55 7.757c.194.353.59.577 1.024.577.434 0 .83-.224 1.024-.577zm-2.047 17.82l-3.551 7.757-8.518 3.234c-.388.176-.633.537-.633.932s.245.756.633.933L48.841 59l3.55 7.756c.194.354.59.577 1.024.577.434 0 .83-.223 1.024-.577L57.99 59l8.517-3.234c.388-.177.634-.538.634-.933s-.246-.756-.634-.932l-8.517-3.234-3.551-7.757c-.194-.353-.59-.577-1.024-.577-.433 0-.83.224-1.023.577z",
  opacity: ".4"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M51.455 35.914c-.001-.805-.455-1.54-1.174-1.902l-14.943-7.487-7.47-14.972c-.723-1.443-3.079-1.443-3.8 0l-7.47 14.972-14.943 7.487a2.124 2.124 0 000 3.806l14.943 7.487 7.47 14.972a2.124 2.124 0 003.8 0l7.47-14.972 14.943-7.484a2.134 2.134 0 001.174-1.907z"
})));

var _default = Sparkles;
exports.default = _default;